<template>
  <div>
    <div class="head_top">

      <div class="head_logo left wow fadeInLeft"><img src="~@/assets/image/logo.png" border="0" /></div>
      <div class="head_right right wow fadeInRight">
        <ul class="head_menu">
          <li><a href="">
              <h2>首页</h2>
            </a></li>
          <li><router-link :to="{ name: 'search' }">
              <h2>产品中心</h2>
            </router-link></li>
          <li><router-link :to="{ name: 'customizedservice' }">
              <h2>定制服务</h2>
            </router-link></li>
          <li><router-link :to="{ name: 'case' }">
              <h2>案例中心</h2>
            </router-link></li>
          <!-- 新增的外链 -->
          <li><a href="https://kyz.kujiale.com/dp/3FO4K0F2WTGC/curation" target="_blank">
              <h2>在线设计</h2>
            </a></li>

          <li><router-link :to="{ name: 'aboutdetail', params: { goodsId: 35 } }">
              <h2>联系我们</h2>
            </router-link></li>
        </ul>

        <template v-if="userInfo">
          <router-link :to="{ name: 'center' }" class="head_zc_btn">个人中心</router-link>
          <router-link @click.native="exit" to="" class="head_login">退出账号</router-link>

        </template>
        <template v-else>
          <router-link :to="{ name: 'register' }" class="head_zc_btn">免费注册</router-link>
          <router-link :to="{ name: 'login' }" class="head_login">登录</router-link>
        </template>

      </div>
      
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
import MainTop from "@/components/common/MainTop.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "Header",
  props: {},
  components: {
    MainTop
  },
  data() {
    return {
      showUserCenter: false,
      userNavArr: [
        {
          title: "个人中心",
          route: "/center"
        },
        {
          title: "我的订单",
          route: "/center/myOrder"
        },
        {
          title: "我的收藏",
          route: "/center/favourite"
        }
      ],
      cartList: [],
      goodsTotalPrice: 0, //购物车总价
      cartShow: false,
      hoverIndex: -1
    };
  },
  created() {
    if (this.$storage.get("userToken")) {
      this.getCartNums();
      this.getCartList();
    }
  },
  watch: {
    cartNums(newVal) {
      this.getCartList();
    }
  },
  computed: {
    ...mapState({
      user: state => state.userInfo,
      cartNums: "cartNums",
      shopMenu: state => state.shopMenu
    }),
    userInfo() {
      if (this.$storage.get("userToken")) {
        return this.user && JSON.stringify(this.user) != "{}"
          ? this.user
          : this.$storage.get("userInfo")
            ? this.$storage.get("userInfo")
            : "";
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions(["getUserInfo", "getCartNumsAction"]),
    // 获取购物车数量
    getCartNums() {
      this.$api.getCartNum().then(res => {
        if (res.status) {
          this.getCartNumsAction(res.data);
        }
      });
    },
    //删除购物车
    removeShop(index, id) {
      this.cartList.splice(index, 1);
      let data = {
        ids: id
      };
      this.$api.removeCart(data).then(res => {
        if (res.status) {
          this.getCartList();
          this.getCartNums();
        }
      });
    },
    //获取购物车列表
    getCartList() {
      this.$api.cartListSelectAll().then(res => {
        if (res.status) {
          this.goodsTotalPrice = res.data.amount;
          this.cartList = res.data.list;
        }
      });
    },
    exit() {
      this.$storage.remove("userToken");
      this.$storage.remove("userInfo");
      this.getUserInfo({});
      if (this.$route.name == "home") {
        this.$router.go(0);
      } else {
        this.$router.replace("/");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";

.head_logo>img {
  max-height: 60px;
}
.head_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  z-index: 9;
}
</style>